export default __webpack_public_path__ + "static/media/nav-exit-inner.86fbb72c.png";